// removed by extract-text-webpack-plugin
module.exports = {"overlay-drop-shadow":"overlay-drop-shadow-a0e8ac","sapcnqr-overlay":"sapcnqr-overlay-0bbbdf","sapcnqr-overlay__content":"sapcnqr-overlay__content-c83a9a"};